import type { ButtonProps } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'features/app/hooks';
import { isInnerLoadingSelector } from 'features/app/store/app/selectors';
import { Button } from 'features/ui/elements';

interface LeaveQueueButtonProps extends ButtonProps {
  onClick: () => void;
}

export const LeaveQueueButton: FC<LeaveQueueButtonProps> = ({
  onClick,
  ...args
}) => {
  const { t } = useTranslation();
  const isInnerLoading = useAppSelector(isInnerLoadingSelector);

  return (
    <Button
      fullWidth
      size='small'
      color='error'
      {...args}
      title={t('leaveQueue')}
      loading={isInnerLoading}
      onClick={() => onClick()}
    >
      {t('callWaiting.leaveQueue')}
    </Button>
  );
};
